module.exports = __webpack_public_path__ + "static/media/dripicons-v2.83598443.svg";